<template>
  <div>
    <a-table
      :columns="columns"
      :dataSource="data"
      :pagination="false"
      :loading="loading"
      :rowKey="record => record.id"
      :scroll="{ x: 1200 }"
      @change="handleTableChange"
    >
      <template slot="severity" slot-scope="severity">
        <span :class="getSeverityClass(severity)">
          {{ severity | capitalize }}
        </span>
      </template>

      <template slot="actions" slot-scope="record">
          <div class="text-nowrap">
            <!-- view -->
            <a-tooltip
              placement="top"
              title="View Record Details"
            >
              <a href="javascript:;" class="btn btn-sm btn-primary mr-2"
                @click="handleView(record)"
              >
                  <i class="btn-addon-icon fe fe-eye" />
              </a>
            </a-tooltip>
            <!-- Edit -->
            <a-tooltip
              placement="top"
              title="Edit Record"
            >
              <a href="javascript:;" v-if="rolesetting.editable" class="btn btn-sm btn-light mr-2"
                @click="handleEdit(record)"
              >
                  <i class="btn-addon-icon fe fe-edit" />
              </a>
            </a-tooltip>
            <!-- Delete -->
            <a-tooltip
              placement="top"
              title="Delete Record"
            >
              <a href="javascript:;" v-if="rolesetting.deletable" class="btn btn-sm btn-danger"
                @click="handleDelete(record)"
              >
                  <i class="btn-addon-icon fe fe-trash" />
              </a>
            </a-tooltip>
          </div>
        </template>
    </a-table>
    <edit-discipline-form
    v-if="editingRecord"
    :record="editingRecord"
    :visible="isEditModalVisible"
    @updated="handleRecordUpdated"
    @close="isEditModalVisible = false"
  />
   <!-- View Modal -->
    <view-discipline-modal
      :visible="isViewModalVisible"
      :recordId="viewRecordId"
      :classMap="classMap"
      @close="isViewModalVisible = false"
    />
  </div>
</template>

<script>
import EditDisciplineForm from '@/components/disciplineManagement/Form/Edit/index.vue'
import ViewDisciplineModal from '@/components/disciplineManagement/display/disciplineView'
export default {
  name: 'DisciplineRecordsTable',
  components: {
    EditDisciplineForm,
    ViewDisciplineModal,
  },
  props: {
    data: Array,
    loading: Boolean,
    rolesetting: Object,
    classMap: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      editingRecord: null,
      isEditModalVisible: false,
      isViewModalVisible: false,
      viewRecordId: null,
      columns: [
        {
          title: 'Date',
          dataIndex: 'incident_date',
          key: 'incident_date',
          width: 110,
          sorter: true,
        },
        {
          title: 'Student Code',
          dataIndex: 'student_code',
          key: 'student_code',
          sorter: true,
          width: 150,
        },
        {
          title: 'Student Name',
          dataIndex: 'student_name',
          key: 'student_name',
          sorter: true,
          width: 250,
        },
        {
          title: 'Class',
          dataIndex: 'class_name',
          key: 'class_name',
          sorter: true,
          width: 100,
        },
        {
          title: 'Section',
          dataIndex: 'section_name',
          key: 'section_name',
          width: 90,
        },
        {
          title: 'Roll No',
          dataIndex: 'roll_no',
          key: 'roll_no',
          sorter: true,
          width: 90,
        },
        {
          title: 'Category',
          dataIndex: 'category_name',
          key: 'category_name',
          width: 130,
        },
        {
          title: 'Penalty',
          dataIndex: 'penalty',
          key: 'penalty',
          width: 140,
        },
        {
          title: 'Severity',
          dataIndex: 'severity',
          key: 'severity',
          scopedSlots: { customRender: 'severity' },
          sorter: true,
          width: 100,
        },
        {
          title: 'Reported By',
          dataIndex: 'reported_by',
          key: 'reported_by',
          width: 160,
        },
        {
          title: 'Actions',
          key: 'actions',
          scopedSlots: { customRender: 'actions' },
          width: 130,
          fixed: 'right',
        },
      ],
    }
  },
  methods: {
    handleTableChange(pagination, filters, sorter) {
      const sorterField = sorter.field
      const sorterOrder = sorter.order === 'ascend' ? 'asc' : sorter.order === 'descend' ? 'desc' : null
      this.$emit('updateTable', [sorterField, sorterOrder, filters])
    },
    getSeverityClass(severity) {
      const classes = {
        minor: 'text-warning',
        medium: 'text-info',
        major: 'text-danger',
      }
      return classes[severity] || ''
    },
    handleView(record) {
      this.viewRecordId = record.id
      this.isViewModalVisible = true
    },
    handleEdit(record) {
      this.editingRecord = record
      this.isEditModalVisible = true
    },
    handleRecordUpdated() {
      this.$emit('updateTable')
      this.isEditModalVisible = false
    },
    handleDelete(record) {
      this.$confirm({
        title: `Are you sure?`,
        content: `Clicking Yes will delete the selected students?`,
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete(`/api/student-discipline/${record.id}`)
            .then(() => {
              this.handleRecordUpdated()
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Deleted Successfully!',
                description: 'Discipline record has been deleted.',
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
  },
  filters: {
    capitalize(value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
  },
}
</script>
